import { Injectable } from '@angular/core';
import { ConfigurationModel, InputConfigModel, AppConstantModel } from '../model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
declare var APP_CONSTANT: any;
@Injectable({
  providedIn: 'root'
})
export class AppBaseService {

  //returnUrl:string='';
 
    appVar: AppConstantModel = new AppConstantModel();

    constructor(public _http: HttpClient) {
        console.log(APP_CONSTANT, "angular");
        this.setAppConstant(APP_CONSTANT);

        //   let obj: InputConfigModel = new InputConfigModel();
        //   obj.URL= 'http://mp6-dev.xeeva.com';// APP_CONSTANT.Customer_URL

        //  let URL: string = 'http://mp6-dev.xeeva.com';

    }

    public handleError(error: HttpErrorResponse) {
        //console.error(error);
        /*   if (error != null) {
               return Observable.throw(error.toString());
           } else {
               return Observable.throw("Error");
           }*/

        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    }
    setAppConstant(obj) {
        this.appVar.Return_URL = obj.Return_URL;
        this.appVar.Customer_URL = obj.Customer_URL;
        this.appVar.IsMP = obj.IsMP;
        this.appVar.UserEmail = obj.UserEmail;
        this.appVar.apiUrl = "";
    }
 
    

    getClientConfig(obj: InputConfigModel): Observable<ConfigurationModel> {
        // let configDetails = new ConfigurationModel();
        let url = this.appVar.apiUrl + '/IDPHome/GetCustomerConfig';

        return this._http.post<ConfigurationModel>(url, obj);
    };
}
